export enum CSSVariables {
  scrollbarWidth = '--scrollbar-width',
  scrollbarPlugWidth = '--scrollbar-plug-width',
  offsetTop = '--offset-top',
}
